import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import {
  brandColours,
  breakpointSizes,
  fluidFontSize,
  fontSize,
  minBreakpointQuery,
  standardColours,
} from '../styles';
import { Link, Svg } from './ui';
import arrow from '../images/arrow.inline.svg';
import cardBackground from '../images/community-story-card-background.inline.svg';

const StyledCommunityStoryCard = styled.article`
  background-color: ${brandColours.quinary};
  margin-top: 25px;
  margin-left: 10px;
`;

const StyledHeader = styled.header`
  --header-bg-colour: ${({ $category }) =>
    $category === 'Stories from Ecotalkers'
      ? brandColours.tertiary
      : $category === 'Nature Workshops'
        ? brandColours.senary
        : $category === 'Projects'
          ? brandColours.primary
          : brandColours.secondary};
  position: relative;
  margin-top: -25px;
  margin-left: -10px;
  margin-right: 10px;
  margin-bottom: 10px;

  ${minBreakpointQuery.small`
    margin-bottom: 15px;
  `}
`;

const StyledHeadingWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  padding: 15px 20px 5px;
  background-color: var(--header-bg-colour);

  ${minBreakpointQuery.small`
    padding-top: 20px;
    padding-bottom: 10px;
    padding-left: 25px;
    padding-right: 25px; 
    gap: 20px;
  `}

  ${minBreakpointQuery.small`
    padding-top: 30px;
    padding-bottom: 15px;
    padding-left: 30px;
    padding-right: 30px; 
  `}
`;

const StyledHeading = styled.h3`
  ${fontSize(28)};
  line-height: 1;

  ${minBreakpointQuery.small`
    ${fontSize(32)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(36)};
  `}
`;

const StyledArrow = styled(Svg)`
  margin-bottom: 6px;
  flex-shrink: 0;
  width: 22px;
  fill: ${standardColours.black};

  ${minBreakpointQuery.small`
    width: 26px;
  `}

  ${minBreakpointQuery.smedium`
    width: 30px;
  `}
`;

const StyledImage = styled(Svg)`
  height: 100%;
  width: 100%;
  margin-top: -1px;
  fill: var(--header-bg-colour);
`;

const StyledText = styled.p`
  padding: 0 30px 30px;
  ${fluidFontSize(
    '14px',
    '22px',
    breakpointSizes.tiny,
    breakpointSizes.xxxxlarge,
  )};
`;

const CommunityStoryCard = communityStory => {
  const { title, introduction, category } = communityStory;

  return (
    <StyledCommunityStoryCard>
      <Link to={communityStory}>
        <StyledHeader $category={category[0]}>
          <StyledHeadingWrapper>
            <StyledHeading>{title}</StyledHeading>
            <StyledArrow image={arrow} />
          </StyledHeadingWrapper>
          <StyledImage image={cardBackground} />
        </StyledHeader>
        <StyledText>{introduction}</StyledText>
      </Link>
    </StyledCommunityStoryCard>
  );
};

export default CommunityStoryCard;

export const CommunityStoryCardFragment = graphql`
  fragment CommunityStoryCardFragment on ContentfulCommunityStory {
    title
    introduction
    category
    ...LinkFragment
  }
`;
